module.exports = __webpack_public_path__ + "img/socials.cda1612d.svg";